import {createSlice} from "@reduxjs/toolkit";

const initialState = {
    isLoadingProducts: false,
    isLoadingExcelProducts: false,
    excelProducts: [],
    products: [],
    count: 0,
    page: 1,
    totalPages: 0,
};

export const productSlice = createSlice({
    name: "products",
    initialState,
    reducers: {
        loadProducts: (state) => {
            state.isLoadingProducts = true;
            state.products = [];
        },
        loadedProducts: (state, action) => {
            state.products = action.payload.result;
            state.count = action.payload.count;
            state.page = action.payload.page;
            state.totalPages = action.payload.totalPages;
            state.isLoadingProducts = false;
        },
        loadExcelProducts: (state) => {
            state.isLoadingExcelProducts = true;
            state.excelProducts = [];
        },
        loadedExcelProducts: (state, action) => {
            state.excelProducts = state.excelProducts.concat(action.payload.result);
        },
        finishLoadedExcelProducts: (state) => {
            state.isLoadingExcelProducts = false;
        },
        search: (state, { payload }) => {
            state.page = 1;
            state.vendors = payload;
        },
        setPage: (state, { payload }) => {
            state.page = payload;
        },
        setLoadingExcelReport: (state, { payload }) => {
            state.isLoadingExcelProducts = payload;
        }
    },
});
export const productActions = productSlice.actions;

export default productSlice.reducer;
